<template>
  <div class="pt-2 pb-2">
    <div class="container-fluid">
      <div class="row">
        <div class="col offset-md-1 text-primary font-weight-bold mb-1">{{ _.nav_browse }}</div>
      </div>
      <div class="row">
        <div class="col" v-bind:class="!isMobile() ? 'offset-1 col-10 p-0':''">
          <div class="row row-cols-1 row-cols-md-2 m-0 g-3">
            <div class="col" v-bind:class="!isMobile() ? '':''" v-if="setting.nav_session === true">
              <button class="btn btn-block btn-outline-primary w-100" data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasTopGroupSelectionSessions">
                <div class="d-flex">
                  <icon :icon="['fad', 'screen-users']" class="fa-6x float-start"/>
                  <h4 class="my-auto mx-auto"><span class="font-weight-bold">{{ _.home_sessions }}</span>
                    <br>({{ Object.keys(sessionlist).length }} {{ _.home_sessions_low }})</h4>
                </div>
              </button>
            </div>
            <div class="col " v-if="setting.nav_theme === true">
              <button class="btn btn-block btn-outline-primary w-100" data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasTopGroupSelectionThemes">
                <div class="d-flex">
                  <icon :icon="['fad', 'layer-group']" class="fa-6x float-start"/>
                  <h4 class="my-auto mx-auto"><span class="font-weight-bold">{{ _.home_topics }}</span>
                    <br>({{ statistics.Themes }} {{ _.home_topics_low }})</h4>
                </div>
              </button>
            </div>
            <div class="col" v-if="setting.nav_author === true">
              <button class="btn btn-block btn-outline-primary w-100" data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasTopGroupSelectionAuthors">
                <div class="d-flex">
                  <icon :icon="['fad', 'users']" class="fa-6x float-start"/>
                  <h4 class="my-auto mx-auto"><span class="font-weight-bold">{{ _.home_authors }}</span> <br>
                    ({{ statistics.Author }} {{ _.home_authors_low }})</h4>
                </div>
              </button>
            </div>
            <div class="col" v-if="setting.nav_title === true">
              <button class="btn btn-block btn-outline-primary w-100"
                      v-on:click="setViewAndGo('title')">
                <div class="d-flex">
                  <icon :icon="['fad', 'sort-alpha-down']" class="fa-6x float-start"/>
                  <h4 class="my-auto mx-auto"><span class="font-weight-bold">{{ _.home_title }}</span><br>
                    ({{ statistics.Poster }} {{ _.home_title_low }})
                  </h4>
                </div>
              </button>
            </div>
          </div>
          <div class="row mt-3 m-0 g-lg-3 row-cols-1" v-if="setting.home_top === true || setting.home_views === true">
            <div class="col" v-if="setting.home_top === true">
              <div class="text-primary font-weight-bold mb-1">{{ _.home_top5 }}</div>
              <ul class="list-group" v-if="ratingstop5.length">
                <router-link
                    class="list-group-item list-group-item-action d-flex justify-content-between align-items-center border-primary"
                    :to="'/viewer/' + toprating.abstract_id" v-for="toprating in ratingstop5">
              <span
                  class="smaller-blank font-weight-bold">{{ toprating.presentation_code }}: {{ toprating.title }}</span>
                  <div class="badge badge-primary badge-pill">{{ toprating.ratings_avg }}</div>
                </router-link>
              </ul>
              <div class="alert-primary text-primary my-auto d-flex" v-else>
                <icon :icon="['far', 'info']" class="ml-2 mt-2 mb-2 fa-3x"/>
                <div class="my-auto"> {{ _.home_no_ratings }}</div>
              </div>
              <span class="smaller float-end">{{ _.home_min_ratings }}</span>
            </div>
            <div class="col" v-if="setting.home_views === true">
              <div class="text-primary font-weight-bold mb-1">{{ _.home_topviews }}</div>
              <ul class="list-group" v-if="views.length">
                <router-link
                    class="list-group-item list-group-item-action d-flex justify-content-between align-items-center border-primary"
                    :to="'/viewer/' + poster.abstract_id" v-for="poster in views">
              <span class="smaller-blank font-weight-bold">{{
                  posters.find(post => post.abstract_id == poster.abstract_id).presentation_code
                }}: {{ posters.find(post => post.abstract_id == poster.abstract_id).title }}</span>
                  <div class="badge badge-primary badge-pill">{{ poster.count }}</div>
                </router-link>
              </ul>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
import {mapState, mapActions, mapMutations} from 'vuex'
import GroupSelectionCards from "./groups/GroupSelectionThemes";

export default {
  components: {GroupSelectionCards},

  computed: {
    ...mapState(['posters', 'mode', 'statistics', 'fullscreen', 'ratings', 'ratingstop5', 'selectedTheme', 'setting', 'views']),
    ...mapState('session', ['sessionlist'])
  },
  methods: {
    ...mapMutations(['setSelectedView']),
    goView() {
      this.$router.push('view');
    },
    setViewAndGo(mode) {
      this.setSelectedView(mode);
      this.goView();
    },
  },
  created() {
    this.$store.dispatch('GET_TOP5_RATINGS');
    this.$store.state.fullscreen = false;
    this.$store.state.presentationSite = null;
  }
}
</script>
